import React from 'react'

import { FormFieldStatus, InputField } from '@gousto-internal/citrus-react'
import { Field, FieldProps } from 'formik'

export const LastNameInput = () => (
  <Field name="lastName">
    {({ field, meta }: FieldProps) => (
      <InputField
        id={field.name}
        data-testid="checkoutLastNameInput"
        autoComplete="family-name"
        label="Last name"
        status={meta.touched && meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.touched ? meta.error : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
      />
    )}
  </Field>
)
